<template>
  <list
    :items="legalTexts"
    type="bullet"
    class="legal-texts-cell uk-margin-remove"
  >
    <template slot="item" scope="{ item }">
      <router-link
        :to="{ name: 'legal-text', params: { id: item.id }}"
        :title="item.plainBody"
      >
        {{item.plainBody | truncate(100)}}
      </router-link>
    </template>
    <text-placeholder slot="empty" />
  </list>
</template>

<script>
import List from '@/components/List';
import TextPlaceholder from '@/components/TextPlaceholder';

export default {
  name: 'legal-texts-cell',
  components: {
    List,
    TextPlaceholder,
  },
  props: {
    legalTexts: {
      type: Array,
      default: () => [],
    },
  },
};
</script>



// WEBPACK FOOTER //
// LegalTextsCell.vue?518356f2